/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetOrCreateRequest
 */
export interface GetOrCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrCreateRequest
     */
    names: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetOrCreateRequest
     */
    workspace: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrCreateRequest
     */
    region?: string;
}

/**
 * Check if a given object implements the GetOrCreateRequest interface.
 */
export function instanceOfGetOrCreateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "names" in value;
    isInstance = isInstance && "workspace" in value;

    return isInstance;
}

export function GetOrCreateRequestFromJSON(json: any): GetOrCreateRequest {
    return GetOrCreateRequestFromJSONTyped(json, false);
}

export function GetOrCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrCreateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'names': json['names'],
        'workspace': json['workspace'],
        'region': !exists(json, 'region') ? undefined : json['region'],
    };
}

export function GetOrCreateRequestToJSON(value?: GetOrCreateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'names': value.names,
        'workspace': value.workspace,
        'region': value.region,
    };
}

